/* Grada FC · extras del carrito: casilla de protección de envío (snippet gfc-protect)
   y recomendaciones con talla y «Añadir» (snippet gfc-cart-recs). Sin librerías.
   Tras cada cambio repinta el carrito lateral con la Section Rendering API del tema (Dawn);
   en la página /cart recarga. */
(function () {
  if (window.gfcCartExtras) return;
  window.gfcCartExtras = true;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function refresh() {
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items');
    if (onCartPage || !drawer || typeof drawer.renderContents !== 'function') {
      location.reload();
      return Promise.resolve();
    }
    return fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) { drawer.renderContents({ sections: sections }); });
  }

  function setQty(variant, qty) {
    var updates = {};
    updates[variant] = qty;
    return post('/cart/update.js', { updates: updates });
  }

  // Protección de envío
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-gfc-protect]');
    if (!box) return;
    box.disabled = true;
    setQty(box.getAttribute('data-variant'), box.checked ? 1 : 0).then(refresh, refresh);
  });

  function fixProtection() {
    var fix = document.querySelector('[data-gfc-protect-fix]:not([data-done])');
    if (!fix) return;
    fix.setAttribute('data-done', '');
    setQty(fix.getAttribute('data-variant'), Number(fix.getAttribute('data-qty'))).then(refresh);
  }

  // Recomendaciones
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cents(p) { return typeof p === 'number' ? p : Math.round(parseFloat(p) * 100); }
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function img(p) {
    var src = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0]));
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=280';
  }

  function card(p) {
    var variants = (p.variants || []).filter(function (v) { return v.available; });
    var opts = variants.map(function (v) {
      return '<option value="' + v.id + '">' + esc(v.title) + '</option>';
    }).join('');
    var single = variants.length === 1 && /default/i.test(variants[0].title);
    return '<div class="gfc-recs__card">' +
      '<a class="gfc-recs__img" href="/products/' + p.handle + '"><img src="' + img(p) + '" alt="' + esc(p.title) + '" loading="lazy" width="136" height="136"></a>' +
      '<a class="gfc-recs__name" href="/products/' + p.handle + '">' + esc(p.title) + '</a>' +
      '<span class="gfc-recs__price">' + money(cents(variants[0].price)) + '</span>' +
      '<div class="gfc-recs__row">' +
        (single ? '<input type="hidden" value="' + variants[0].id + '">' : '<select aria-label="Talla de ' + esc(p.title) + '">' + opts + '</select>') +
        '<button type="button" data-gfc-rec-add>Añadir</button>' +
      '</div></div>';
  }

  function fillRecs(box) {
    box.setAttribute('data-done', '');
    var rail = box.querySelector('[data-gfc-recs-rail]');
    var exclude = (box.getAttribute('data-exclude') || '').split(',');
    var seen = {};
    var picked = [];
    function take(list) {
      (list || []).forEach(function (p) {
        var id = String(p.id);
        var type = p.type || p.product_type;
        var ok = !seen[id] && exclude.indexOf(id) === -1 && type !== 'Servicio' &&
          (p.variants || []).some(function (v) { return v.available; });
        if (ok && picked.length < 6) { seen[id] = true; picked.push(p); }
      });
    }
    var url = '/recommendations/products.json?limit=10&product_id=' + box.getAttribute('data-product-id');
    fetch(url).then(function (r) { return r.json(); }).then(function (d) { take(d.products); }, function () {})
      .then(function () {
        if (picked.length >= 4) return;
        return fetch('/collections/' + box.getAttribute('data-fallback') + '/products.json?limit=10')
          .then(function (r) { return r.json(); }).then(function (d) { take(d.products); }, function () {});
      })
      .then(function () {
        if (!picked.length) { box.classList.add('is-empty'); return; }
        rail.innerHTML = picked.map(card).join('');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gfc-rec-add]');
    if (!btn) return;
    var field = btn.parentNode.querySelector('select, input');
    btn.disabled = true;
    btn.textContent = '…';
    post('/cart/add.js', { items: [{ id: Number(field.value), quantity: 1 }] }).then(refresh, function () {
      btn.disabled = false;
      btn.textContent = 'Añadir';
    });
  });

  function scan() {
    fixProtection();
    var boxes = document.querySelectorAll('[data-gfc-recs]:not([data-done])');
    for (var i = 0; i < boxes.length; i++) fillRecs(boxes[i]);
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  function start() {
    scan();
    ['cart-drawer', 'cart-items'].forEach(function (tag) {
      var el = document.querySelector(tag);
      if (el) new MutationObserver(queue).observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
